import { render, staticRenderFns } from "./PushGuidePopup.vue?vue&type=template&id=af1563c4"
import script from "./PushGuidePopup.vue?vue&type=script&lang=js"
export * from "./PushGuidePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af1563c4')) {
      api.createRecord('af1563c4', component.options)
    } else {
      api.reload('af1563c4', component.options)
    }
    module.hot.accept("./PushGuidePopup.vue?vue&type=template&id=af1563c4", function () {
      api.rerender('af1563c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/PushGuidePopup.vue"
export default component.exports